export default __webpack_public_path__ + "static/media/sound.4ac14c70.mp3";